import axios, { AxiosInstance } from "axios";
import { supabase } from "./supabaseClient";

const axiosClient: AxiosInstance = axios.create();

let isRefreshing = false;
let refreshQueue: Array<(token: string | null) => void> = [];

function drainQueue(token: string | null) {
  refreshQueue.forEach((resolve) => resolve(token));
  refreshQueue = [];
}

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;

    if (error.response?.status !== 401 || config?._retry) {
      return Promise.reject(error);
    }

    config._retry = true;

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        refreshQueue.push((token) => {
          if (!token) return reject(error);
          config.headers["Authorization"] = `Bearer ${token}`;
          resolve(axiosClient(config));
        });
      });
    }

    isRefreshing = true;

    try {
      const { data, error: refreshError } = await supabase.auth.refreshSession();
      const newToken = data?.session?.access_token ?? null;
      isRefreshing = false;

      if (refreshError || !newToken) {
        drainQueue(null);
        await supabase.auth.signOut();
        return Promise.reject(error);
      }

      drainQueue(newToken);
      config.headers["Authorization"] = `Bearer ${newToken}`;
      return axiosClient(config);
    } catch {
      isRefreshing = false;
      drainQueue(null);
      return Promise.reject(error);
    }
  },
);

export default axiosClient;
